// routes
import Router from "./routes";
// theme
import ThemeConfig from "./theme";
import GlobalStyles from "./theme/globalStyles";
// components
import ScrollToTop from "./components/ScrollToTop";
import { BaseOptionChartStyle } from "./components/charts/BaseOptionChart";

// redux store
import Store from "./redux/Store";
import { Provider } from "react-redux";
import { RegionConfigProvider } from "./RegionConfigProvider";

import axios from "axios";

const origin = window.location.origin;
const isDevServer = window.location.port === "3000";
const apiHost =
    window.location.hostname === "localhost"
        ? "127.0.0.1"
        : window.location.hostname;

if (isDevServer) {
    axios.defaults.baseURL = `http://${apiHost}:8000`;
} else {
    axios.defaults.baseURL = origin;
}

// ----------------------------------------------------------------------

export default function App() {
    return (
        <ThemeConfig>
            <ScrollToTop />
            <GlobalStyles />
            <BaseOptionChartStyle />
            <Provider store={Store}>
                <RegionConfigProvider>
                <Router />
                </RegionConfigProvider>
            </Provider>
        </ThemeConfig>
    );
}
